import SectionHead from "../SectionHead";
import { Reveal } from "../motion";
import { useLang } from "../../i18n";

const HowItWorks = () => {
    const { t } = useLang();
    return (
        <section data-testid="how-it-works-section" className="bg-olive text-cream">
            <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-28">
                <Reveal>
                    <p className="text-xs font-bold uppercase tracking-[0.22em] text-sand">{t.steps.eyebrow}</p>
                    <h2 className="font-serif mt-3 max-w-2xl text-3xl font-semibold tracking-tight sm:text-4xl lg:text-5xl">
                        {t.steps.title}
                    </h2>
                </Reveal>
                <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                    {t.steps.items.map((step, i) => (
                        <Reveal key={step.num} delay={i * 0.1}>
                            <div className="group relative h-full rounded-[1.5rem] border border-cream/15 bg-olive-dark/40 p-7 transition-colors duration-300 hover:bg-olive-dark/70">
                                <span className="font-serif text-4xl font-bold italic text-sand/80 transition-colors duration-300 group-hover:text-terracotta">
                                    {step.num}
                                </span>
                                <h3 className="font-serif mt-4 text-xl font-semibold">{step.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-cream/75">{step.desc}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
